import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า คอเลสเตอรอล โดยใช้ค่าปกติจาก medium.json
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'คอเลสเตอรอลรวม', gender, age, 'คอเลสเตอรอล');
};
